import { isPresent } from "~/tools/is-present";
import { namableAlphabeticalSorter } from "~/tools/namable-alphabetical-sorter";
import type { Object } from "~/tools/object";

import type { ExternalComponent, ExternalRelation, FullComponent, FullRelation } from "../../common/openapi";
import { jsonToYaml } from "../../generic/yamlUtils";

export interface SyncCode {
	name: string;
	code: string;
}

export const useQuerySyncsCodeByElementId = ({
	element,
}: {
	element: FullRelation | FullComponent;
}): null | Array<SyncCode> =>
	element.synced
		.map((extTopoElement) => {
			const name = extTopoElement?.syncName;
			return name == null ? null : { name, code: stringifyData(extTopoElement) };
		})
		.filter(isPresent)
		.sort(namableAlphabeticalSorter);

export const stringifyData = (data?: ExternalComponent | ExternalRelation): string => {
	const input =
		data && "sourceProperties" in data && data.sourceProperties != null
			? data.sourceProperties
			: (data?.data as Object);
	return jsonToYaml(input);
};
